import { IPurchaseOrder } from '../../purchase-order';

export interface IOrderSalesPicklistPreview {
  pickingItems :IOrderSalesPicklistPreviewItem[];
  orders :IOrderSalesPicklistPreviewOrder[];
  warehouseAddress ?:IOrderSalesShipstationAddress | null;
}

export interface IOrderSalesPicklistPreviewItem {
  rfqId :number;
  internalSku :string;
  productName :string;
  locationId :number;
  locationName :string;
  lotNumber :string;
  quantity :number;
  availableQuantity :number;
  fulfilled :boolean;
  orderNumber :string;
  incomingOrders :IOrderSalesPicklistPreviewIncomingOrder[];
  photo ?:string;
}

export interface IOrderSalesPicklistPreviewIncomingOrder {
  id :number;
  purchase_order :IPurchaseOrder;
  ordered_qty :number;
}

export interface IOrderSalesPicklistPreviewOrder {
  id :number;
  orderNumber :string;
  shipTo :string;
  shipDate :string;
  salesOrderId :number;
  carrierCode :string;
  serviceCode :string;
  packageCode :string;
  weight :string;
  dimensions :string;
  confirmation :string;
  shipToString :string;
  orderItemsCount :number;
  hasMultipleShipments ?:boolean;
  salesOrderShipments ?:any[];
}

export interface IOrderSalesShipstationAddress {
  name :string;
  company :string;
  street1 :string;
  phone ?:string | null;
  postalCode :string;
  city :string;
  state :string;
  country :string;
  // OLD DATA SUPPORT
  postal_code :string;
}

export enum EPicklistPreviewSortId {
  INTERNAL_SKU = 'internalSku',
  PRODUCT_NAME = 'productName',
  LOCATION_NAME = 'locationName',
  LOT_NUMBER = 'lotNumber',
  QUANTITY = 'quantity',
  AVAILABLE_QUANTITY = 'availableQuantity',
}
